import { CLOSE, OPEN } from '../../utils/constants';
import { appointmentChannelId, form, isBookAppointment, patientSelected, procedures, setIsClickCheckBox } from '../../utils/variables';
import { removeAllAddons, toggleAddonsPopup } from '../actions/addonActions';
import {
    addProcedure,
    isCheckedProcedure,
    removeProcedure,
    toggleProcedureDescription,
} from '../actions/procedureActions';
import { params } from './movePages';

export function procedureListeners() {
    /* on click checkbox */
    const procedureItems = document.querySelectorAll('.line__wrapper.procedure');
    const checkBox = document.querySelectorAll('.line__wrapper.procedure .procedure__checkbox');
    const enableCategorySelection = form?.appointment_channel?.enable_category_selection;
    const enableCategorySelectionForConsultation = form?.is_category_enabled;

    if (isBookAppointment && !patientSelected && !enableCategorySelection && !enableCategorySelectionForConsultation) {
        document
            .querySelector('.seeServices__container .procedure__actions .backOneStep__btn')?.classList.add('visibility-hidden');
        document
            .querySelector('.seeServices__container  .back-arrow')?.classList.add('visibility-hidden');
    } else {
        document
            .querySelector('.seeServices__container .procedure__actions .backOneStep__btn')?.classList?.remove('visibility-hidden');
        document
            .querySelector('.seeServices__container  .back-arrow')?.classList?.remove('visibility-hidden');
    }

    if (params('mobile')) {
        document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.add('hide');
    } else {
        document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.remove('hide');
    }

    const procedureList = (appointmentChannelId && form?.appointment_channel?.procedures?.length > 1) ? form?.appointment_channel?.procedures : procedures;
    procedureItems.forEach((element, index) => {
        const procedure = procedureList.find(
            (p) => p.id === parseInt(element.getAttribute('data-procedure-id'))
        );
        const category = element.getAttribute('data-category');

        checkBox[index].addEventListener('click', (event) => {
            event.stopPropagation();
            setIsClickCheckBox(true);
            const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);

            if (filterAddOns?.length > 0) {
                if (procedure.addons_required) {
                    setIsClickCheckBox(false);
                }
                /* Toggle addon popup */
                if (isCheckedProcedure(procedure.id)) {
                    removeProcedure(procedure.id);
                    removeAllAddons(procedure.id);
                } else {
                    toggleAddonsPopup(procedure.id, category, OPEN);
                }
            } else {
                if (isCheckedProcedure(procedure.id)) {
                    removeProcedure(procedure.id);
                } else {
                    addProcedure(procedure.id);
                }
            }
        });

        element.addEventListener('click', () => {
            const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);
            if (filterAddOns?.length > 0) {
                if (isCheckedProcedure(procedure.id)) {
                    removeProcedure(procedure.id);
                    removeAllAddons(procedure.id);
                } else {
                    setIsClickCheckBox(false);
                    toggleAddonsPopup(procedure.id, category, OPEN);
                }
            } else {
                checkBox[index].click();
            }
        });
    });

    /* on click show information */
    const infoBtn = document.querySelectorAll(
        '.procedure__information.procedure'
    );
    infoBtn.forEach((i) => {
        const procedureId = i.getAttribute('data-procedure-id');

        i.onclick = (e) => {
            e.stopPropagation();
            toggleProcedureDescription(procedureId, OPEN);
        };
    });

    /* on click close information */
    const closeBtn = document.querySelectorAll('.procedure-body__close-btn');
    closeBtn.forEach((i) => {
        const id = i.getAttribute('data-procedure-id');

        i.onclick = () => {
            toggleProcedureDescription(id, CLOSE);
        };
    });

    /* on click outside to close information */
    const bg = document.querySelectorAll(
        '.popup__background.procedure__information'
    );
    bg.forEach((i) => {
        const id = i.getAttribute('data-procedure-id');

        i.onclick = () => {
            toggleProcedureDescription(id, CLOSE);
        };
    });

    /* on click Add/Remove Procedure Button */
    const btn = document.querySelectorAll('.procedure-body__add-procedure-btn');
    btn.forEach((i) => {
        const id = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');

        i.onclick = () => {
            if (isCheckedProcedure(id)) {
                removeProcedure(id);
                removeAllAddons(id);
            } else {
                const procedure = procedures.find((i) => i.id === id);
                const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);
                if (filterAddOns?.length > 0) {
                    toggleAddonsPopup(procedure.id, category, OPEN);
                } else {
                    addProcedure(id);
                }

            }
            toggleProcedureDescription(id, CLOSE);
        };
    });

    /* On click enter */
    const screenProcedures = document
        .querySelector('.screen--procedures');

    if (screenProcedures) {
        screenProcedures.addEventListener('keydown', handlePressEnter);
    }
}

function handlePressEnter(event) {
    if (event.key === 'Enter' && !document
        .querySelector('.procedureContinue__btn').classList.contains('disabled')) {
        document
            .querySelector('.procedureContinue__btn').click();
    }
}
